import { Link } from 'react-router-dom';
import { JourneyLines } from './JourneyLines';
import { CoachingStatus, MovementList } from './CompanionBlocks';
import { NextUnlock } from './NextUnlock';
import { ArrowRight, ClipboardList } from 'lucide-react';

/** The snapshot. Fast, light, high-signal — not the full journey. */
export const CompanionSnapshot = ({ data, onOpenFull }) => {
  const latest = data.timeline?.[0];

  return (
    <div className="space-y-6" data-testid="companion-snapshot">
      <CoachingStatus coaching={data.coaching} compact />

      <NextUnlock />

      {latest ? (
        <section data-testid="snapshot-latest">
          <h3 className="text-xs uppercase tracking-wider text-white/40 mb-2">
            Latest assessment
          </h3>
          <div className="rounded-xl border border-white/10 bg-white/[0.03] p-4">
            <div className="flex items-baseline justify-between gap-3">
              <span className="text-sm text-white/90">{latest.label}</span>
              <span className="text-xs text-white/40">
                {new Date(latest.submitted_at).toLocaleDateString()}
              </span>
            </div>
            <p className="text-xs text-white/50 mt-2">{latest.focus_statement}</p>
            <div className="mt-3">
              <MovementList movements={latest.movements} />
            </div>
            <div className="text-xs text-white/40 mt-3">
              Overall {latest.overall_score}% · {latest.overall_stage_name}
            </div>
          </div>
        </section>
      ) : (
        <section data-testid="snapshot-no-assessment">
          <div className="rounded-xl border border-white/10 bg-white/[0.03] p-4 text-sm text-white/60">
            No assessment yet. Your first one opens when you enter Module 2.
          </div>
        </section>
      )}

      <section>
        <h3 className="text-xs uppercase tracking-wider text-white/40 mb-2">
          Dimensional snapshot
        </h3>
        <JourneyLines dimensions={data.dimensions} axis={data.axis} compact />
      </section>

      <section className="space-y-2" data-testid="snapshot-actions">
        <button
          onClick={onOpenFull}
          className="w-full flex items-center justify-between rounded-xl bg-white/10 hover:bg-white/15
                     px-4 py-3 text-sm text-white transition-colors duration-200"
          data-testid="snapshot-view-full-btn"
        >
          View full journey <ArrowRight className="w-4 h-4" />
        </button>
        <Link
          to="/dashboard/modules"
          className="w-full flex items-center justify-between rounded-xl border border-white/10
                     hover:bg-white/5 px-4 py-3 text-sm text-white/80 transition-colors duration-200"
          data-testid="snapshot-modules-btn"
        >
          Coaching Program <ClipboardList className="w-4 h-4" />
        </Link>
      </section>

      <footer className="pt-2 flex flex-wrap gap-x-3 gap-y-1 text-[11px] text-white/30">
        <Link to="/terms" className="hover:text-white/60">Terms of Service</Link>
        <span>·</span>
        <Link to="/privacy" className="hover:text-white/60">Privacy Policy</Link>
        <span>·</span>
        <Link to="/community-guidelines" className="hover:text-white/60">Community Guidelines</Link>
      </footer>
    </div>
  );
};

export default CompanionSnapshot;
